import { TimelineLite, Power2 } from 'gsap'
import bus from './bus'
import UI from './utils/UI'

UI({
  component: '.js-drawerMenu',
  links: ['.js-drawerMenu-link'],
  decorations: ['.js-drawerMenu-decoration']
}, ({ component, links, decorations }) => {
  bus.on('drawer-open-start', _ => { [...decorations, ...links].forEach(el => (el.style.opacity = 0)) })
  bus.on('drawer-open-ready', _ => {
    const linksTl = new TimelineLite()
    const decorationTl = new TimelineLite()
    links.forEach((link, index) => { linksTl.fromTo(link, 0.15, { opacity: 0, scale: 0 }, { opacity: 1, scale: 1, ease: Power2.easeInOut }, index === 0 ? 0 : '-=.1') })
    decorations.forEach(decoration => decorationTl.to(decoration, 0.2, { opacity: 1, ease: Power2.easeInOut }, '-=0.15'))
  })
})
